module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "gheader"
  }, [(_vm.isStaging) ? _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("テスト環境")]) : _c('h1', {
    staticClass: "gheader__logo"
  }, [_c('a', {
    on: {
      "click": _vm.goLogin
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/logo.png"),
      "alt": ""
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b00324ec!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-header-noauth.pug
// module id = 1437
// module chunks = 1